document.addEventListener('DOMContentLoaded', function () {
  function findGalleryContainer() {
    return document.querySelector('.slider-mobile-gutter');
  }

  const checkGallery = setInterval(() => {
    const gallery = findGalleryContainer();
    if (gallery) {
      clearInterval(checkGallery);
      initializeImageLoading(gallery);
    }
  }, 100);

  let hasLoaded = false;

  function initializeImageLoading(gallery) {
    let firstImage = gallery.querySelector('.slider__slide.is-active img');
    if (!firstImage) {
      firstImage = gallery.querySelector('.slider__slide img');
    }

    const lazyImages = gallery.querySelectorAll('img[loading="lazy"]');

    function loadLazyImages() {
      if (hasLoaded) return;
      hasLoaded = true;
      lazyImages.forEach((img) => {
        img.removeAttribute('loading');
        if (!img.complete) img.src = img.src;
      });
    }

    if (firstImage) {
      if (firstImage.complete) {
        setTimeout(loadLazyImages, 100);
      } else {
        firstImage.addEventListener('load', () => setTimeout(loadLazyImages, 100), { once: true });
      }
    }
  }
});